import { useEffect, useRef } from "react";
import { am4charts, am4core, initAmCharts } from "./AmCharts";

export default function DonutChart({
  id = "chartdiv",
  data = [],
  className,
  value,
  category,
  textCenter,
  tooltipText
}) {
  const chartRef = useRef(null);
  const labelRef = useRef(null);

  useEffect(() => {
    initAmCharts();

    let chart = am4core.create(id, am4charts.PieChart);
    chart.innerRadius = am4core.percent(50);

    let series = chart.series.push(new am4charts.PieSeries());
    series.dataFields.value = value;
    series.dataFields.category = category;

    series.labels.template.text = "{value.percent.formatNumber('#.0')}%";

    series.slices.template.stroke = am4core.color("#fff");
    series.slices.template.strokeWidth = 2;
    series.slices.template.strokeOpacity = 1;
    if (tooltipText) {
      series.slices.template.tooltipText = tooltipText;
    }

    series.hiddenState.properties.opacity = 1;
    series.hiddenState.properties.endAngle = -90;
    series.hiddenState.properties.startAngle = -90;

    series.tooltip.getFillFromObject = false;
    series.tooltip.background.fill = am4core.color("#fff");
    series.tooltip.label.fill = am4core.color("#000");

    let label = chart.seriesContainer.createChild(am4core.Label);
    label.text = textCenter != null && textCenter !== "" ? `${textCenter}` : "";
    label.horizontalCenter = "middle";
    label.verticalCenter = "middle";
    label.fontSize = 14;
    labelRef.current = label;

    let legend = new am4charts.Legend();
    legend.position = "top";
    legend.valueLabels.template.disabled = true;
    legend.labels.template.text = "{category}";
    chart.legend = legend;

    if (Array.isArray(data) && data.length > 0) {
      chart.data = data;
    }

    chartRef.current = chart;

    return () => {
      if (chart && !chart.isDisposed()) {
        chart.dispose();
      }
      chartRef.current = null;
      labelRef.current = null;
    };
  }, [id, value, category, tooltipText]);

  useEffect(() => {
    if (chartRef.current && !chartRef.current.isDisposed()) {
      chartRef.current.data = Array.isArray(data) ? data : [];
    }
  }, [data]);

  useEffect(() => {
    if (labelRef.current && (!chartRef.current || !chartRef.current.isDisposed())) {
      labelRef.current.text = textCenter != null && textCenter !== "" ? `${textCenter}` : "";
    }
  }, [textCenter]);

  return (
    <>
      <div id={id} className={className}></div>
    </>
  );
}